/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Tooltip from '@material-ui/core/Tooltip';
import { transparentize, CHART_COLORS } from 'src/utils/chartsUtils';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import Card from 'src/components/sharedComponents/Card/Card';
import formatNumbersMiles from 'src/utils/formatNumbersMiles';
import Popover from '@material-ui/core/Popover';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import { IconButton } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';

const useStyles = makeStyles({
  root: {
    maxWidth: 250,
    minWidth: 240,
    minHeight: 250,
    marginRight: '10px',
    boxShadow: '0 4px 6px black',
    borderRadius: '5px',
    transition: '0.5s',
  },
  media: {
    height: 80,
  },
  table: {
    borderColor: transparentize(CHART_COLORS.orange, 0.4),
  },
  tableCell: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

const CardMapValue = (props) => {
  const {
    atributos = [],
    handleRemoveCard,
    caracteristicas = [],
    stateEdit,
    result = 0,
    new_modelo,
    lider = [],
  } = props;
  const classes = useStyles();
  const colorIndex = Object.keys(CHART_COLORS).findIndex(
    (itemColor) => itemColor === props?.empresa?.toLowerCase(),
  );

  const setLider = lider[lider.length - 1 || 0];

  return (
    <Card
      style={{
        backgroundColor: transparentize(
          Object.values(CHART_COLORS)[colorIndex]
            || Object.values(CHART_COLORS)[8],
          0.5,
        ),
      }}
      className={classes.root}
      plain
    >
      <CardHeader
        style={{
          background: transparentize(
            Object.values(CHART_COLORS)[colorIndex]
              || Object.values(CHART_COLORS)[8],
            0,
          ),
        }}
        color="customAuteco"
      >
        <ul>{props.empresa}</ul>
      </CardHeader>
      <CardActionArea>
        <CardContent>
          <section
            className={classes.media}
            style={{ display: 'inline-flex', alignItems: 'center' }}
          >
            <Typography gutterBottom variant="h6" component="h6">
              {props.linea}
            </Typography>
            {'  '}
            {!stateEdit ? (
              <>
                <IconButton
                  onClick={handleRemoveCard}
                  alt="Elminar"
                  style={{ color: '#0060B6' }}
                >
                  <DeleteSweepIcon />
                </IconButton>
              </>
            ) : null}
            <>
              <PopupState variant="popover" popupId="demo-popup-popover">
                {(popupState) => (
                  <div>
                    <IconButton
                      variant="contained"
                      {...bindTrigger(popupState)}
                      edge="end"
                      style={{ color: '#B20612' }}
                    >
                      <EqualizerIcon />
                    </IconButton>
                    <Popover
                      {...bindPopover(popupState)}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                    >
                      <Box p={2}>
                        <>
                          <TableContainer component={Paper}>
                            <Table
                              size="small"
                              aria-label="a dense table"
                              dense
                              // table
                            >
                              <TableBody>
                                {caracteristicas.map((caracteristica) => (
                                  <TableRow key={caracteristica.id}>
                                    <TableCell component="th" scope="row">
                                      {caracteristica.caracteristica}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                      {caracteristica.valor || 0}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </>
                      </Box>
                    </Popover>
                  </div>
                )}
              </PopupState>
            </>
          </section>
          <Typography variant="body2" color="textSecondary" component="p">
            <TableContainer component={Paper}>
              <Table
                className={classes.table}
                size="small"
                aria-label="a dense table"
                dense
              >
                <TableBody>
                  {atributos.map(({ atributo, valor, id }) => (
                    <TableRow key={id}>
                      <Tooltip title={atributo} arrow>
                        <TableCell component="th" size="small" scope="row">
                          {atributo.slice(0, 10) || 'No.'}
                          ...
                        </TableCell>
                      </Tooltip>
                      <TableCell align="left">{valor || 0}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <br />
            <TableContainer component={Paper}>
              <Table
                className={classes.table}
                size="small"
                aria-label="a dense table"
                dense
              >
                <TableBody>
                  <TableRow>
                    <TableCell component="th" size="small" scope="row">
                      V.percibido
                    </TableCell>
                    <TableCell component="th" size="small" align="right">
                      {props?.vpercibido?.toFixed(2) || 0}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" size="small" scope="row">
                      VPC
                    </TableCell>
                    <TableCell component="th" size="small" align="right">
                      {(
                        ((+props?.unidades || 0) / (+setLider?.unidades || 0))
                        * +setLider?.vpercibido
                      ).toFixed(2) || 0}
                    </TableCell>
                  </TableRow>
                  <TableRow key="total">
                    <TableCell component="th" size="small" scope="row">
                      Precio
                    </TableCell>
                    <TableCell component="th" size="small" align="right">
                      $
                      {formatNumbersMiles(props.precio)}
                    </TableCell>
                  </TableRow>
                  <TableRow key="descuento">
                    <TableCell
                      component="th"
                      size="small"
                      scope="row"
                      align="left"
                    >
                      Descuento
                    </TableCell>
                    <TableCell component="th" size="small" align="right">
                      $
                      {formatNumbersMiles(props.promocion)}
                    </TableCell>
                  </TableRow>
                  <TableRow key="pneto">
                    <TableCell component="th" size="small" scope="row">
                      P. Neto
                    </TableCell>
                    <TableCell component="th" size="small" align="right">
                      $
                      {formatNumbersMiles(props.vneto || 0)}
                    </TableCell>
                  </TableRow>
                  <TableRow key="unidades">
                    <TableCell component="th" size="small" scope="row">
                      U mes anterior
                    </TableCell>
                    <TableCell component="th" size="small" align="right">
                      <div className={classes.tableCell}>
                        {formatNumbersMiles(props.unidades || 0)}
                        {' '}
                        {props.unidades > props.proyectado ? (
                          <ArrowDropUpIcon style={{ color: 'green' }} />
                        ) : (
                          <ArrowDropDownIcon style={{ color: 'red' }} />
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow key="unidades_proyectado">
                    <TableCell component="th" size="small" scope="row">
                      Und pry
                    </TableCell>
                    <TableCell component="th" size="small" align="right">
                      {formatNumbersMiles(props.proyectado || 0)}
                    </TableCell>
                  </TableRow>
                  <TableRow key="market">
                    <TableCell component="th" size="small" scope="row">
                      M. share
                    </TableCell>
                    <TableCell component="th" size="small" align="right">
                      {(((+props.unidades || 0) / +result || 0) * 100)?.toFixed(
                        2,
                      ) || 0}
                      %
                    </TableCell>
                  </TableRow>
                  {new_modelo
                  && new_modelo !== NaN
                  && new_modelo !== -Infinity ? (
                    <>
                      <TableRow key="pp">
                        <TableCell component="th" size="small" scope="row">
                          Proyectado
                        </TableCell>
                        <TableCell component="th" size="small" align="right">
                          {new_modelo?.toFixed(2)}
                        </TableCell>
                      </TableRow>
                    </>
                    ) : null}
                </TableBody>
              </Table>
            </TableContainer>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CardMapValue;
